import { useState } from 'react'
import { Platform } from 'react-native'

import { useToast } from '@zet/common/components/toast'
import webDocumentUpload from '@zet/common/utils/webDocumentUpload'
// import webDocumentUpload from '@zet/design-system/webDocumentUpload'
import * as DocumentPicker from 'expo-document-picker'

import { useGetDocumentUploadURL } from '../../api/getDocumentUploadUrl/hooks'
import { useDocumentUploadToS3 } from '../../api/uploadDocumentToS3/hooks'
import { brandsI18n } from '../../localization'

const useDocumentPicker = (fieldId: string) => {
  const [selectedDocument, setSelectedDocument] = useState(null)
  const [isUploading, setIsUploading] = useState(false)
  const [documentName, setDocumentName] = useState(null)
  const { refetch } = useGetDocumentUploadURL(fieldId)
  const { mutate, isSuccess, data } = useDocumentUploadToS3()
  const toast = useToast()

  const getBlob = async (fileUri: string) => {
    const resp = await fetch(fileUri)
    const imageBody = await resp.blob()
    return imageBody
  }

  const pickDocument = async (fieldId: string) => {
    let result, cancenlled, webDocumentResponse
    try {
      if (Platform.OS === 'web') {
        webDocumentResponse = await webDocumentUpload.getDocumentAsync({
          type: '*/*',
          multiple: false,
        })

        cancenlled = webDocumentResponse?.canceled
        result = webDocumentResponse?.assets?.[0]
      } else {
        result = await DocumentPicker.getDocumentAsync()
        cancenlled = result?.canceled
      }

      if (!cancenlled) {
        if (webDocumentResponse?.assets?.[0]?.mimeType !== 'application/pdf') {
          toast?.show({
            intent: 'error',
            heading: brandsI18n.t('toastMessages.error'),
            description: 'Please upload pdf file',
            hideAfter: 3000,
          })
        } else if (webDocumentResponse?.assets?.[0]?.size > 2000000) {
          toast?.show({
            intent: 'error',
            heading: brandsI18n.t('toastMessages.error'),
            description: 'Please upload document less than 2 MB',
            hideAfter: 3000,
          })
        } else {
          setIsUploading(true)
          setSelectedDocument(result?.uri)
          setDocumentName(result?.name)
          if (fieldId) {
            const imageBody = await getBlob(result?.uri)

            const presignedUrlResponse = await refetch()
            if (presignedUrlResponse?.status === 'success') {
              mutate({
                S3Url: presignedUrlResponse?.data?.results,
                file: imageBody,
              })
              setIsUploading(false)
            }
          }
        }
      } else {
        setSelectedDocument(null)
      }
    } catch (error) {
      console.log('Error picking document:', error)
    }
  }

  return {
    selectedDocument,
    pickDocument,
    documentName,
    setDocumentName,
    isUploading,
  }
}
export { useDocumentPicker }
